import React, { useState, useEffect, useContext } from "react";
import { styled, useTheme } from "@mui/material/styles";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import axios from "axios";
import calendarpng from "./../Asset/New_Assert/ESO_Icon/Filter.svg";
import pdficon from "./../Asset/PDF.png";
import csvicon from "./../Asset/CSV.png";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import fav_icon from "./../Asset/New_Assert/ESO_ICON.png";
import Select from 'react-select';
import LiquidFillGauge from "react-liquid-gauge";
import { color } from "d3-color";
import { interpolateRgb } from "d3-interpolate";
import { useSelector } from "react-redux";

import { Outlet, Link } from "react-router-dom";
import BacklinksTrend from "./BacklinksTrend";
import BackLinksSummary from "./BacklinksSummary";
import BacklinksResearch from "./BacklinksResearch";
import Linklists from "./New_link/Linklists";
import LinkedDomainList from "./LinkedDomainList";
import CompetitorBacklinks from "./CompetitorBacklinks";
import BacklinksReport from "./BacklinksReport";
import RunReportNow from "../RunReportNow";
import { ToastContainer, toast } from 'react-toastify';
import Rightsidebar from "../Rightsidebar/Rightsidebar";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import { Commonfun, removeDuplicateDate } from './../Commonfun';
import { AppContext } from "../../../Context/Context";
import { useNavigate } from 'react-router-dom';
import { timezonechange } from './../Commonfun';
import { timezoneval } from './../Commonfun';
import { Utils } from "../../../Utils/Utils";
import Freeaudit from "../../../Utils/Freeaudit";
import { datezonechange } from "./../Commonfun"
import Loader from "../CommonLoader";
import CommonAlert from "../../../Commonalert/commonalert";
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import { customDropdownStyles } from "../../../Commonalert/commonDropdown";
import { Breadcrumbs, Typography } from "@mui/material";
import GetAppIcon from '@mui/icons-material/GetApp';
import PdfandCsv from "../PdfandCsv";
import { CommonErrorAlert } from "../../../Commonalert/commonErrorAlert";
import CommonBreadCrumb from "../../../Commonalert/commonbreadcrumb";
import {Container, Grid, Box} from '@mui/material';
import { height } from "@mui/system";

export default function BackLinksIndex() {
  const { isMenuExpanded, setIsMenuExpanded } = useContext(AppContext);
  const [cardData, setCardData] = useState([]);
  const [jobidData, setjobidData] = useState("");
  const [loading, setLoading] = useState(false);
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [jobDate, setjobDate] = useState("");
  const [completedate, setcompletedate] = useState([]);
  const [selectval, setSelectval] = useState({ label: '', value: '' });
  const [campaign, Setcampaign] = useState("");
  const [campaignoption, Setcampaignoption] = useState([]);
  const [ErrorMsg, SetErrorMsg] = useState("");
  const [selectjobid, setselectjobid] = useState("");
  const [SearchEngine, SetSearchEngine] = useState("");
  const [Countryoptions, SetCountryoptions] = useState([]);
  const [Stateoptions, SetStateoptions] = useState([]);
  const [CityOptions, SetCityOptions] = useState([]);
  const [Engineoptions, SetEngineoptions] = useState([]);
  const [Country, SetCountry] = useState("");
  const [State, SetState] = useState("");
  const [City, SetCity] = useState("");
  const [System, SetSystem] = useState('');
  const [Device, SetDevice] = useState('')
  const [backlinkurl, SetBacklinkurl] = useState('')
  const [newButtonlink, SetnewButtonlink] = useState('1')
  const esodata = useSelector((state) => state);
  const [SubmitTriggered, SetSubmitTriggered] = useState(false)
  const ApiToken = esodata.apiauthkey.value
  const [apiopen, setapiOpen] = React.useState(false);
  const [apierrorMsg, setapierrorMsg] = useState();
  const [CurrentMenu, SetCurrentMenu] = useState('backlinks_summary')
  const [CurrentMenuName, SetCurrentMenuName] = useState('Backlinks Summary')
  const [faqData, setfaqData] = useState("2")
  const [toggle, setToggle] = useState(false);
  const [initialfaqDateval, SetInitialfaqDateval] = useState([]);
  const [blSummaryPlan, setblSummaryPlan] = useState({ status: false, error: "" });
  const [blResearchPlan, setblResearchPlan] = useState({ status: false, error: "" });
  const [blNewLostPlan, setblNewLostPlan] = useState({ status: false, error: "" });
  const [blLinkedDomainPlan, setblLinkedDomainPlan] = useState({ status: false, error: "" });
  const [blTrendPlan, setblTrendPlan] = useState({ status: false, error: "" });
  const [blReportsPlan, setblReportsPlan] = useState({ status: false, error: "" });
  const [blCompetitorPlan, setblCompetitorPlan] = useState({ status: false, error: "" });
  const [isDownloading, setIsDownloading] = useState(false);
  const [isDownloadingcsv, setIsDownloadingcsv] = useState(false);
  const [openCommonAlerts, setOpenCommonAlerts] = useState(true);
  const [showVerifyPopup, setShowVerifyPopup] = useState(false);
  const [competitorsID, setCardDatasID] = useState([]);
  const [competitorsValue, setCompetitorsValue] = useState(null);
  const [competitors, setCardDatas] = useState([]);
  console.log("competitorsID-1", competitorsID);

  const navigate = useNavigate();

  const SwitchMenu = (e) => {
    setShowVerifyPopup(false);
    const Id = e.target.getAttribute('data-id')
    const Name = e.target.getAttribute('data-name')

    SetRankCampaign('')
    SetRankJob('')
    SetRankEngine('')
    SetRankCountry('')
    SetRankState('')
    SetRankCity('')
    SetRankSystem('')
    SetRankDevice('')
    SetCurrentMenu(Id)
    SetCurrentMenuName(Name)
    faqdatafun(Id)
  }


  const apihandleClose = () => {
    setapiOpen(false);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const SetCountryHandle = async (value) => {
    SetStateoptions([]);
    if (value) {
      SetCountry(value.value);
      try {
        const statedatavalue = await axios.get(
          `${process.env.REACT_APP_API_URL}keywords/ranking_filter/?job_id=${selectjobid}&user_domain_id=${esodata.domaindata.value.header_selected}&campaign_id=${campaign}&search_engine_id=${SearchEngine}&country_id=${value.value}&city_id=${City}&filter_type=state`,
          {
            headers: {
              Authorization: `${ApiToken}`,
            },
          }
        );
        if (statedatavalue?.data) {
          if (statedatavalue?.data?.states) {
            var Sections = [];
            statedatavalue.data.states.forEach((element) => {
              Sections.push({
                label: element.search_engine_locale__city__state__state_name,
                value: element.search_engine_locale__city__state__id,
              });
            });
            SetStateoptions(Sections);
          }
        }
      } catch (err) {
        console.log(err);
      }
    }
  };

  const SetStateHandle = async (value) => {
    SetCityOptions([]);
    if (value) {
      SetState(value);

      const citydatavalue = await axios.get(
        `${process.env.REACT_APP_API_URL}keywords/ranking_filter/?job_id=${selectjobid}&user_domain_id=${esodata.domaindata.value.header_selected}&campaign_id=${campaign}&search_engine_id=${SearchEngine}&country_id=${Country}&state_id=${value.value}&filter_type=city`,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      );

      if (citydatavalue?.data) {
        if (citydatavalue?.data?.cities) {
          var Sections = [];
          citydatavalue.data.cities.forEach((element) => {
            Sections.push({
              label: element.search_engine_locale__city__city_name,
              value: element.search_engine_locale__city__id,
            });
          });
          SetCityOptions(Sections);
        }
      }
    }
  };

  const [FilterButtonTriggered, SetFilterButtonTriggered] = useState(false)

  const finalreportNow = async () => {
    setLoading(true);
    SetErrorMsg("");
    if (
      selectjobid !== "" ||
      campaign !== "" ||
      SearchEngine !== "" ||
      Country !== "" ||
      State.value !== "" ||
      City.value !== "" ||
      System !== '' ||
      Device !== ''

    ) {


      SetRankCampaign(campaign)

      SetRankJob(selectjobid)
      SetRankEngine(SearchEngine)
      SetRankCountry(Country)

      if (State.value) {
        SetRankState(State.value)
      }
      if (City.value) {
        SetRankCity(City.value)
      }


      SetRankSystem(System)
      SetRankDevice(Device)
      SetFilterButtonTriggered(true)


    } else {
      setLoading(false);
      return SetErrorMsg("Please Select the All Fields !");
    }
    closeModal();
    setLoading(false);
  };

  const [validation, setValidation] = useState({
    dateerror: "",
  });


  const [RankCampaign, SetRankCampaign] = useState('')
  const [RankJob, SetRankJob] = useState('')
  const [RankEngine, SetRankEngine] = useState('')
  const [RankCountry, SetRankCountry] = useState('')
  const [RankState, SetRankState] = useState('')
  const [RankCity, SetRankCity] = useState('')
  const [RankSystem, SetRankSystem] = useState('')
  const [RankDevice, SetRankDevice] = useState('')






  const LoadAddFormFilterOptions = async (jobid = "") => {
    setjobidData([]);
    SetCountryoptions([]);
    SetEngineoptions([]);
    Setcampaignoption([])
    try {
      const campaigndatavalue = await axios.get(
        `${process.env.REACT_APP_API_URL}domain/get_report_job_details/?user_domain_id=${esodata.domaindata.value.header_selected}&job_type=backlinks`,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      );
      if (campaigndatavalue?.data?.jobs) {
        if (campaigndatavalue?.data?.jobs) {
          // var campaignSections = [];
          // campaigndatavalue.data.jobs.forEach((element) => {
          //   campaignSections.push({ label: datezonechange(element.completed_at), value: element.id });
          // });
          const uniqueByCompletedAt = removeDuplicateDate(campaigndatavalue?.data?.jobs);
          if (uniqueByCompletedAt.length > 0) {
            SetdEngineoption(uniqueByCompletedAt[0]);
            SetPrevdEngineoption(uniqueByCompletedAt[0]);
            setcompletedate(uniqueByCompletedAt);
            setjobDate(uniqueByCompletedAt[0]?.value())
          }

        }
      }
    } catch (err) { }

  };

  const checkUserPlan = async () => {
    const blSummaryP = await Utils("backlinks_summary", ApiToken);
    const blResearchP = await Utils("backlinks_research", ApiToken);
    const blNewLostP = await Utils("backlinks_new_lost", ApiToken);
    const blLinkedDomainP = await Utils("backlinks_linked_domain", ApiToken);
    const blTrendP = await Utils("backlinks_trend", ApiToken);
    const blReportsP = await Utils("backlinks_reports", ApiToken);
    const blCompetitorP = await Utils("backlinks_reports", ApiToken);
    setblSummaryPlan(blSummaryP);
    setblResearchPlan(blResearchP);
    setblNewLostPlan(blNewLostP);
    setblLinkedDomainPlan(blLinkedDomainP);
    setblTrendPlan(blTrendP);
    setblReportsPlan(blReportsP);
    setblCompetitorPlan(blCompetitorP);
  };

  const arr = [];

  useEffect(() => {
    checkUserPlan();
    LoadAddFormFilterOptions()
    var buttonval = CurrentMenu;
    faqdatafun(buttonval)
  }, []);

  useEffect(() => {
    if (CurrentMenu) {
      setShowVerifyPopup(true);
    }
  }, [backlinkurl, newButtonlink, CurrentMenu]);

  function openModal() {
    setIsOpen(true);
  }
  function closeModal(triggerClose = false) {
    if (triggerClose) {
      SetdEngineoption(prevdEngineoption);
      setSelectval(prevdEngineoption);
    }
    setIsOpen(false);
  }

  const FilterFunction = () => {
    var errs = 1;
    let errors = {};

    if (selectval == "") {
      errors.dateerror = "This field is required.";
      errs = 2;
    } else {
      errors.dateerror = "";
      errs = 1;
      setValidation(errors);
    }
    if (errs == 2) {
      return setValidation(errors);
    }
    SetFilterButtonTriggered(true);
    SetPrevdEngineoption(dEngineoption);
  }

  const [RunReportPopShow, SetRunReportPopShow] = useState(false)
  const [RunReportType, SetRunReportType] = useState('backlinks')

  const [dEngineoption, SetdEngineoption] = useState({
    label:
      'Select Date',
    value:
      'Select Date',
  });
  const [prevdEngineoption, SetPrevdEngineoption] = useState({
    label:
      'Select Date',
    value:
      'Select Date',
  });


  const pdfdown = async () => {

    setLoading(true);
    setIsDownloading(true);
    if (CurrentMenu === 'backlinks_summary') {
      var backdataurl = `${process.env.REACT_APP_API_URL}backlinks/v2/backlinks_summary/?user_domain_id=${esodata.domaindata.value.header_selected}&job_id=${selectval?.value}&is_format=pdf&timezone=${timezoneval()}`;
      var dummyname = "Backlinks Summary"
    }
    else if (CurrentMenu === "backlinks_report") {
      var dummyname = "Backlinks Report"
      var backdataurl = `${process.env.REACT_APP_API_URL}backlinks/v2/backlinks_report/?user_domain_id=${esodata.domaindata.value.header_selected}&job_id=${selectval?.value}&is_format=pdf&timezone=${timezoneval()}`;
    }
    else if (CurrentMenu === "competitor_backlinks") {
      var dummyname = "Competitor Backlinks"
      var backdataurl = `${process.env.REACT_APP_API_URL}backlinks/competitor_backlinks_research/?user_domain_id=${esodata.domaindata.value.header_selected}&job_id=${selectval?.value}&is_format=pdf&timezone=${timezoneval()}&competitor_id=${competitorsValue.value}`;
    }
    else if (CurrentMenu === "backlinks_trend") {
      var backdataurl = `${process.env.REACT_APP_API_URL}backlinks/v2/backlinks_trend_table/?user_domain_id=${esodata.domaindata.value.header_selected}&job_id=${selectval?.value}&formats=pdf&timezone=${timezoneval()}`;
      var dummyname = "Backlinks Trends"

    }
    else if (CurrentMenu === "linked_domains") {
      var backdataurl = `${process.env.REACT_APP_API_URL}backlinks/v2/linked_domain_table/?user_domain_id=${esodata.domaindata.value.header_selected}&job_id=${selectval?.value}&formats=pdf&timezone=${timezoneval()}`;
      var dummyname = "Linked Domains"
    }

    else if (CurrentMenu === "backlinks_research") {
      if (backlinkurl == "") {
        var backdataurl = `${process.env.REACT_APP_API_URL}backlinks/v2/backlinks_research/?user_domain_id=${esodata.domaindata.value.header_selected}&job_id=${selectval?.value}&is_format=pdf&timezone=${timezoneval()}`;
        var dummyname = "Backlinks Research"
      }
      else {
        var backdataurl = `${process.env.REACT_APP_API_URL}backlinks/v2/backlinks_research/?user_domain_id=${esodata.domaindata.value.header_selected}&job_id=${selectval?.value}&is_format=pdf&request_url=${backlinkurl}&timezone=${timezoneval()}`
        var dummyname = "Backlinks Research"
      }

    }
    else if (CurrentMenu === "new_lost_links") {

      if (newButtonlink == 1) {
        var dummyname = "NewLink"

        var backdataurl = `${process.env.REACT_APP_API_URL}backlinks/v2/backlinks_new_lost/?user_domain_id=${esodata.domaindata.value.header_selected}&job_id=${selectval?.value}&link_type=new&is_format=pdf&timezone=${timezoneval()}`;
      }
      else {
        var dummyname = "LostLink"
        var backdataurl = `${process.env.REACT_APP_API_URL}backlinks/v2/backlinks_new_lost/?user_domain_id=${esodata.domaindata.value.header_selected}&job_id=${selectval?.value}&link_type=lost&is_format=pdf&timezone=${timezoneval()}`;
      }
    }

    try {
      const response = await fetch(backdataurl, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/pdf',
          Authorization: `${ApiToken}`,
        },
      });
      if (response.ok) {
        const blob = await response.blob();

        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        var filedata = await Commonfun(dummyname, "pdf", ApiToken, esodata.domaindata.value.header_selected);
        link.download = filedata;
        link.click();
        window.URL.revokeObjectURL(link.href);
      } else {
        if (response?.status == 599 || response?.status == 500 || response?.status == 400 || response?.status == 404) {
          response.json().then(data => {
            setapiOpen(true);
            setapierrorMsg(data?.error)
          })
        }
        else if (response?.code == "ERR_NETWORK") {
          navigate('/errorpages')
        }
      }
    } catch (error) {
      toast.error("No Data", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      console.error('Error during PDF download:', error);
    }
    setLoading(false);
    setIsDownloading(false);


  }
  const csvdown = async () => {
    setLoading(true);
    setIsDownloadingcsv(true);
    var dummyname = "Backlinks Summary"
    if (CurrentMenu === 'backlinks_summary') {
      var backdataurl = `${process.env.REACT_APP_API_URL}backlinks/v2/backlinks_summary/?user_domain_id=${esodata.domaindata.value.header_selected}&job_id=${selectval?.value}&is_format=csv&timezone=${timezoneval()}`;
    }
    else if (CurrentMenu === "backlinks_report") {
      dummyname = "Backlinks Report"
      var backdataurl = `${process.env.REACT_APP_API_URL}backlinks/v2/backlinks_report/?user_domain_id=${esodata.domaindata.value.header_selected}&job_id=${selectval?.value}&is_format=csv&timezone=${timezoneval()}`;
    }

    else if (CurrentMenu === "competitor_backlinks") {
      dummyname = "Competitor Backlinks";
      var backdataurl = `${process.env.REACT_APP_API_URL}backlinks/competitor_backlinks_research/?user_domain_id=${esodata.domaindata.value.header_selected}&job_id=${selectval?.value}&is_format=csv&timezone=${timezoneval()}&competitor_id=${competitorsValue.value}`;
    }

    else if (CurrentMenu === "backlinks_trend") {
      dummyname = "Backlinks Trends"
      var backdataurl = `${process.env.REACT_APP_API_URL}backlinks/v2/backlinks_trend_table/?user_domain_id=${esodata.domaindata.value.header_selected}&job_id=${selectval?.value}&formats=csv&timezone=${timezoneval()}`;
    }
    else if (CurrentMenu === "linked_domains") {
      dummyname = "Linked Domains"
      var backdataurl = `${process.env.REACT_APP_API_URL}backlinks/v2/linked_domain_table/?user_domain_id=${esodata.domaindata.value.header_selected}&job_id=${selectval?.value}&formats=csv&timezone=${timezoneval()}`;
    }
    else if (CurrentMenu === "backlinks_research") {
      dummyname = "Backlinks Research"
      if (backlinkurl == "")
        var backdataurl = `${process.env.REACT_APP_API_URL}backlinks/v2/backlinks_research/?user_domain_id=${esodata.domaindata.value.header_selected}&job_id=${selectval?.value}&is_format=csv&timezone=${timezoneval()}`;
      else
        var backdataurl = `${process.env.REACT_APP_API_URL}backlinks/v2/backlinks_research/?user_domain_id=${esodata.domaindata.value.header_selected}&job_id=${selectval?.value}&is_format=csv&request_url=${backlinkurl}&timezone=${timezoneval()}`
    }
    else if (CurrentMenu === "new_lost_links") {
      if (newButtonlink == 1) {
        dummyname = "NewLink"
        var backdataurl = `${process.env.REACT_APP_API_URL}backlinks/v2/backlinks_new_lost/?user_domain_id=${esodata.domaindata.value.header_selected}&job_id=${selectval?.value}&link_type=new&is_format=csv&timezone=${timezoneval()}`;
      }
      else {
        dummyname = "LostLink"
        var backdataurl = `${process.env.REACT_APP_API_URL}backlinks/v2/backlinks_new_lost/?user_domain_id=${esodata.domaindata.value.header_selected}&job_id=${selectval?.value}&link_type=lost&is_format=csv&timezone=${timezoneval()}`;
      }
    }
    try {
      const response = await fetch(backdataurl, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/pdf',
          Authorization: `${ApiToken}`,
        },
      });
      if (response.ok) {
        const blob = await response.blob();
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        var filedata = await Commonfun(dummyname, "csv", ApiToken, esodata.domaindata.value.header_selected);
        link.download = filedata;
        link.click();
        window.URL.revokeObjectURL(link.href);
      } else {
        if (response?.status == 599 || response?.status == 500 || response?.status == 400 || response?.status == 404) {
          response.json().then(data => {
            setapiOpen(true);
            setapierrorMsg(data?.error)
          })
        }
        else if (response?.code == "ERR_NETWORK") {
          navigate('/errorpages')
        }
      }
    } catch (error) {
      toast.error("No Data", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      console.error('Error during PDF download:', error);
    }
    setLoading(false);
    setIsDownloadingcsv(false);

  }

  const faqdatafun = async (menubutval = "") => {

    if (menubutval === 'backlinks_summary')
      var datavar = `${process.env.REACT_APP_API_URL}domain/frequently_asked_questions/?menu=25`
    else if (menubutval === "backlinks_report")
      var datavar = `${process.env.REACT_APP_API_URL}domain/frequently_asked_questions/?menu=30`
    else if (menubutval === "competitor_backlinks")
      var datavar = `${process.env.REACT_APP_API_URL}domain/frequently_asked_questions/?menu=67`
    else if (menubutval === "backlinks_trend")
      var datavar = `${process.env.REACT_APP_API_URL}domain/frequently_asked_questions/?menu=29`
    else if (menubutval === "linked_domains")
      var datavar = `${process.env.REACT_APP_API_URL}domain/frequently_asked_questions/?menu=28`
    else if (menubutval === "backlinks_research")
      var datavar = `${process.env.REACT_APP_API_URL}domain/frequently_asked_questions/?menu=26`
    else if (menubutval === "new_lost_links")
      var datavar = `${process.env.REACT_APP_API_URL}domain/frequently_asked_questions/?menu=27`
    try {
      const doaminsectiondatavalue = await axios.get(
        datavar,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      );
      if (doaminsectiondatavalue?.data) {
        SetInitialfaqDateval(doaminsectiondatavalue?.data?.faqs)
      }
    } catch (err) { }
  }
  const handleToggle = () => {
    if (faqData != 1) {
      setfaqData(1)
    }
    else {
      setfaqData(2)
    }
    setToggle((pre) => !pre);
  };

  const freeAuditPlanPdfCsv = () => {

    const planStatusMap = [
      { plan: blSummaryPlan, currentMenu: 'backlinks_summary' },
      { plan: blResearchPlan, currentMenu: 'backlinks_research' },
      { plan: blNewLostPlan, currentMenu: 'new_lost_links' },
      { plan: blLinkedDomainPlan, currentMenu: 'linked_domains' },
      { plan: blTrendPlan, currentMenu: 'backlinks_trend' },
      { plan: blReportsPlan, currentMenu: 'backlinks_report' },
      { plan: blCompetitorPlan, currentMenu: 'competitor_backlinks' }
    ]

    return planStatusMap.map((menuPlan, index) => {
      return (
        <>
          {(CurrentMenu === menuPlan.currentMenu && menuPlan.plan.status) && (
            <div key={index} className="exportpdf_outer">
              <button onClick={handleToggle} className="faq_class exportpdf" title="Frequently Asked Question" >
                <QuestionMarkIcon />
              </button>
              <PdfandCsv Downloadval={1} isDownloadingcsv={isDownloadingcsv} isDownloading={isDownloading}
                csvdown={csvdown} pdfdown={pdfdown} />
            </div>
          )}
        </>
      );
    });
  }

  const freeAuditPlanFilter = () => {

    const planStatusMap = [
      { plan: blSummaryPlan, currentMenu: 'backlinks_summary' },
      { plan: blResearchPlan, currentMenu: 'backlinks_research' },
      { plan: blNewLostPlan, currentMenu: 'new_lost_links' },
      { plan: blLinkedDomainPlan, currentMenu: 'linked_domains' },
      { plan: blTrendPlan, currentMenu: 'backlinks_trend' },
      { plan: blReportsPlan, currentMenu: 'backlinks_report' },
      { plan: blCompetitorPlan, currentMenu: 'competitor_backlinks' }
    ]

    return planStatusMap.map((menuPlan, index) => {
      return (
        <>
          {(CurrentMenu === menuPlan.currentMenu) && (
            <>
              <div className="drop_down_button">
                <button className="btn_dashboard" style={{ marginLeft: "auto" }} onClick={() => { SetRunReportPopShow(true) }} disabled={!menuPlan.plan.status}>
                  Run Report Now
                </button>
              </div>

            </>
          )}
        </>
      );
    });
  }

  function handleReset() {
    SetdEngineoption("");
    setSelectval("")
  }

  return (
    <div className={`over_all_container ${isMenuExpanded ? "blur overflow-hidden" : ""}`}>
      {loading === true ? <Loader /> : null}
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />


      <Container maxWidth={false} className="dashboard-container">
        <Box className="dashboard-box">
          <Grid container className="dashboard-grid">
            <Grid item xs={12} md={4}>
              <div>
                <h1 className="dashboard_header">
                                  {CurrentMenuName} {CurrentMenu === "backlinks_summary" && <span className="_btn_icon_calender">
                  {/* <img src={calendarpng} alt="calender logo" onClick={blSummaryPlan.status ? openModal : null} /> */}
                </span>}
                  <span className="faq-chip" onClick={handleToggle}>FAQ's</span>
                </h1>
              </div>
            </Grid>
            <Grid item xs={12} md={8}>
              <div className="top_breadcrumb_menu">
                <div className="exportpdf_outer">
                  <div className="breadcrumb-wrapper">
                    <CommonBreadCrumb breadcrumbValue={[
                      { title: 'Backlinks' },
                      { title: CurrentMenuName, activeColor: true }
                    ]} />
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>

      <Container maxWidth={false} className="dashboard-container">
        <Box className="dashboard-box-time">
          <Grid container className="dashboard-grid">
            <Grid item xs={12} md={6}>
              <div className="time_zone">
                <span className="timezone-date">{timezonechange(jobDate)} </span><br />
                <span className="timezone-val">{timezoneval()}</span>
              </div>
            </Grid>
            <Grid item xs={12} md={6}>
              <div style={{ display: "flex", justifyContent: "end", alignItems: "center", gap: "20px" }}>
                <div>
                  {CurrentMenu === "competitor_backlinks" &&
                    <div style={{ marginTop: "-25px" }}>
                      <div style={{ fontWeight: "400", color: "#ff601f" }}>Select Competitor</div>
                      <Select className="dropdown_height" style={{ height: "45px !important" }}
                        value={competitorsValue}
                        options={competitors}
                        menuPlacement="auto"
                        menuShouldScrollIntoView={false}
                        onChange={(selectedOption) => {
                          setCompetitorsValue(selectedOption); // Update state
                          // if (selectedOption?.value) {
                          //   LoadDataTable(selectedOption.value); 
                          // }
                        }}
                        styles={customDropdownStyles()}
                        getOptionLabel={(option) => option.label}
                        getOptionValue={(option) => option.value}
                        placeholder="Select Competitor..."
                        menuPortalTarget={document.body}
                      />
                    </div>
                  }
                </div>
                {freeAuditPlanFilter()}
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>


<Container maxWidth={false} className="dashboard-container">
          <Box className="dashboard-box-tab">
            <Grid container className="dashboard-grid">
            <Grid item xs={12} md={12}>
              <div className="trendy-tabs-wrapper">
                <div className="trendy-tab-container">
                  <button
                    type="button"
                    data-id="backlinks_summary"
                    className={`trendy-tab ${CurrentMenu === "backlinks_summary" ? "active" : ""}`}
                    onClick={SwitchMenu} data-name='Backlinks Summary'
                  >
                    Backlinks Summary
                  </button>
                  <button
                    type="button"
                    data-id="backlinks_research"
                    className={`trendy-tab ${CurrentMenu === "backlinks_research" ? "active" : ""}`}
                    onClick={SwitchMenu} data-name='Backlinks Summary'
                  >
                    Backlinks Research
                  </button>

                  <button
                    type="button"
                    data-id="new_lost_links"
                    className={`trendy-tab ${CurrentMenu === "new_lost_links" ? "active" : ""}`}
                    onClick={SwitchMenu} data-name='New/Lost Links'
                  >
                    New/Lost Links
                  </button>
                  <button
                    type="button"
                    data-id="linked_domains"
                    className={`trendy-tab ${CurrentMenu === "linked_domains" ? "active" : ""}`}
                    onClick={SwitchMenu} data-name=' Linked Domains'
                  >
                    Linked Domains
                  </button>

                  <button
                    type="button"
                    data-id="backlinks_trend"
                    className={`trendy-tab ${CurrentMenu === "backlinks_trend" ? "active" : ""}`}
                    onClick={SwitchMenu} data-name='Backlinks Trend'
                  >
                    Backlinks Trend
                  </button>
                  <button
                    type="button"
                    data-id="backlinks_report"
                    className={`trendy-tab ${CurrentMenu === "backlinks_report" ? "active" : ""}`}
                    onClick={SwitchMenu} data-name='  Backlinks Reports'
                  >
                    Backlinks Reports
                  </button>
                  <button
                    type="button"
                    data-id="competitor_backlinks"
                    className={`trendy-tab ${CurrentMenu === "competitor_backlinks" ? "active" : ""}`}
                    onClick={SwitchMenu} data-name='Competitor Backlinks'
                  >
                    Competitor Backlinks
                  </button>
                </div>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>




      <div className="cnt_audit_outer_wrap">
        <div className="">
          
          {/* <div className="exportpdf_outer">
            {freeAuditPlanPdfCsv()}
          </div> */}
          {toggle && <Rightsidebar close={() => setToggle(false)} setToggle={setToggle} initialfaqDateval={initialfaqDateval} />}

        </div>
        {/* <div className="">
          <div className="">
            <h2 className=""  >
              {CurrentMenuName} {CurrentMenu === "backlinks_summary" && <span className="_btn_icon_calender">
              <img src={calendarpng} alt="calender logo" onClick={blSummaryPlan.status ? openModal : null} />
            </span>}
              {CurrentMenu === "backlinks_research" && <span className="_btn_icon_calender">
                <img src={calendarpng} alt="calender logo" onClick={blResearchPlan.status ? openModal : null} />
              </span>}
              {CurrentMenu === "new_lost_links" && <span className="_btn_icon_calender">
                <img src={calendarpng} alt="calender logo" onClick={blNewLostPlan.status ? openModal : null} />
              </span>}
              {CurrentMenu === "linked_domains" && <span className="_btn_icon_calender">
                <img src={calendarpng} alt="calender logo" onClick={blLinkedDomainPlan.status ? openModal : null} />
              </span>}
              {CurrentMenu === "backlinks_trend" && <span className="_btn_icon_calender">
                <img src={calendarpng} alt="calender logo" onClick={blTrendPlan.status ? openModal : null} />
              </span>}
              {CurrentMenu === "backlinks_report" && <span className="_btn_icon_calender">
                <img src={calendarpng} alt="calender logo" onClick={blReportsPlan.status ? openModal : null} />
              </span>}
              {CurrentMenu === "competitor_backlinks" && <span className="_btn_icon_calender">
                <img src={calendarpng} alt="calender logo" onClick={blCompetitorPlan.status ? openModal : null} />
              </span>}
            </h2>
            <p style={{ fontSize: "14px", letterSpacing: "0.8px", color: "#ff601fc2" }}>as of {timezonechange(jobDate)}  <span style={{ fontWeight: 700 }}>  {timezoneval()} </span></p>
          </div>
          <div style={{ display: "flex", alignItems: "self-end", gap: "12px" }}>
            {CurrentMenu === "competitor_backlinks" &&
              <div>
                <div style={{ fontWeight: "400", color: "#ff601f" }}>Select Competitor</div>
                <Select style={{ marginLeft: "15px" }}
                  value={competitorsValue}
                  options={competitors}
                  menuPlacement="auto"
                  menuShouldScrollIntoView={false}
                  onChange={(selectedOption) => {
                    setCompetitorsValue(selectedOption); 
                  }}
                  styles={customDropdownStyles()}
                  getOptionLabel={(option) => option.label}
                  getOptionValue={(option) => option.value}
                  placeholder="Select Competitor..."
                  menuPortalTarget={document.body}
                />
              </div>
            }

          </div>
        </div> */}

        {/* <div className="link_cnt_hdr_blw_wrap googleanlytics" style={{ marginBottom: "15px" }}>

          <button data-id="backlinks_summary" className={CurrentMenu === 'backlinks_summary' ? 'runreportnews active' : 'runreportnews'} onClick={SwitchMenu} data-name='Backlinks Summary'>
            Backlinks Summary
          </button>

          <button data-id="backlinks_research" className={CurrentMenu === 'backlinks_research' ? 'runreportnews active' : 'runreportnews'} onClick={SwitchMenu} data-name='Backlinks Research' >
            Backlinks Research
          </button>
          <button data-id="new_lost_links" className={CurrentMenu === 'new_lost_links' ? 'runreportnews active' : 'runreportnews'} onClick={SwitchMenu} data-name='New/Lost Links'>
            New/Lost Links
          </button>
          <button data-id="linked_domains" className={CurrentMenu === 'linked_domains' ? 'runreportnews active' : 'runreportnews'} onClick={SwitchMenu} data-name='Linked Domains' style={{ marginBottom: "15px" }}>
            Linked Domains
          </button>

          <button data-id="backlinks_trend" className={CurrentMenu === 'backlinks_trend' ? 'runreportnews active' : 'runreportnews'} onClick={SwitchMenu} data-name='Backlinks Trend'>
            Backlinks Trend
          </button>
          <button data-id="backlinks_report" className={CurrentMenu === 'backlinks_report' ? 'runreportnews active' : 'runreportnews'} onClick={SwitchMenu} data-name='Backlinks Report'>
            Backlinks Reports
          </button>
          <button data-id="competitor_backlinks" className={CurrentMenu === 'competitor_backlinks' ? 'runreportnews active' : 'runreportnews'} onClick={SwitchMenu} data-name='Competitor Backlinks'>
            Competitor Backlinks
          </button>


        </div> */}


        {
          CurrentMenu === 'backlinks_trend' ? (blTrendPlan.status ? <BacklinksTrend RankJob={selectval} FilterButtonTriggered={FilterButtonTriggered} SetFilterButtonTriggered={SetFilterButtonTriggered} jobDate={jobDate} setjobDate={setjobDate} closeModal={closeModal} openModal={openModal} csvdown={csvdown} pdfdown={pdfdown}/> : <Freeaudit planStatus={blTrendPlan} />) : null
        }

        {

          CurrentMenu === 'backlinks_summary' ? (blSummaryPlan.status ? <BackLinksSummary RankJob={selectval} FilterButtonTriggered={FilterButtonTriggered} SetFilterButtonTriggered={SetFilterButtonTriggered} jobDate={jobDate} setjobDate={setjobDate} closeModal={closeModal} openModal={openModal} csvdown={csvdown}
            pdfdown={pdfdown} /> : <Freeaudit planStatus={blSummaryPlan} />) : null
        }

        {

          CurrentMenu === 'backlinks_research' ? (blResearchPlan.status ? <BacklinksResearch RankJob={selectval} FilterButtonTriggered={FilterButtonTriggered} SetFilterButtonTriggered={SetFilterButtonTriggered} jobDate={jobDate} setjobDate={setjobDate} closeModal={closeModal} backlinkurl={backlinkurl} SetBacklinkurl={SetBacklinkurl}  openModal={openModal} csvdown={csvdown} pdfdown={pdfdown}/> : <Freeaudit planStatus={blResearchPlan} />) : null

        }

        {

          CurrentMenu === 'new_lost_links' ? (blNewLostPlan.status ? <Linklists RankJob={selectval} setSelectval={setSelectval} FilterButtonTriggered={FilterButtonTriggered} SetFilterButtonTriggered={SetFilterButtonTriggered} jobDate={jobDate} setjobDate={setjobDate} closeModal={closeModal} SetnewButtonlink={SetnewButtonlink} newButtonlink={newButtonlink} openModal={openModal} csvdown={csvdown} pdfdown={pdfdown}/> : <Freeaudit planStatus={blNewLostPlan} />) : null

        }

        {

          CurrentMenu === 'linked_domains' ? (blLinkedDomainPlan.status ? <LinkedDomainList RankJob={selectval} FilterButtonTriggered={FilterButtonTriggered} SetFilterButtonTriggered={SetFilterButtonTriggered} jobDate={jobDate} setjobDate={setjobDate} closeModal={closeModal} openModal={openModal} csvdown={csvdown} pdfdown={pdfdown}/> : <Freeaudit planStatus={blLinkedDomainPlan} />) : null

        }
        {

          CurrentMenu === 'backlinks_report' ? (blReportsPlan.status ? <BacklinksReport RankJob={selectval} FilterButtonTriggered={FilterButtonTriggered} SetFilterButtonTriggered={SetFilterButtonTriggered} jobDate={jobDate} setjobDate={setjobDate} closeModal={closeModal} openModal={openModal} csvdown={csvdown} pdfdown={pdfdown}/> : <Freeaudit planStatus={blReportsPlan} />) : null

        }
        {

          CurrentMenu === 'competitor_backlinks' ? (blCompetitorPlan.status ?
            <CompetitorBacklinks competitorsID={competitorsID} RankJob={selectval}
              setCardDatasID={setCardDatasID} FilterButtonTriggered={FilterButtonTriggered}
              SetFilterButtonTriggered={SetFilterButtonTriggered} jobDate={jobDate} setjobDate={setjobDate}
              closeModal={closeModal} competitors={competitors} setCardDatas={setCardDatas} competitorsValue={competitorsValue} setCompetitorsValue={setCompetitorsValue} openModal={openModal} csvdown={csvdown} pdfdown={pdfdown}/> :
            <Freeaudit planStatus={blCompetitorPlan} />) : null

        }

        {showVerifyPopup &&
          <CommonAlert setOpenCommonAlerts={setOpenCommonAlerts} />
        }

        <Container maxWidth={false} sx={{ maxWidth: "1500px" }} style={{ marginTop: "5px", marginBottom: "5px" }} >
          <Box style={{ padding: "0px 20px 0px 20px" }} >
            <Grid container style={{ display: "flex", alignItems: "center" }} >
              <Grid item xs={12} md={6}>
                <div><p style={{ color: "#000" }}>All Rights Reserved Copyright © 2025 | <span style={{ color: "#ff601f" }}> eGrove Systems</span></p></div>
              </Grid>
              <Grid item xs={12} md={6}>
                <div style={{ display: "flex", gap: "30px", justifyContent: "end" }}>
                  <p>
                    {/* <span
                          style={{ color: "#818181", cursor: "pointer" }}
                          onClick={handleToggle}
                        >
                          FAQ's
                        </span> */}
                  </p></div>
              </Grid>
            </Grid>
          </Box>
        </Container>



        <Dialog
          open={modalIsOpen}
          onClose={() => { closeModal(true) }}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          className="competitor_test_filter job_date_filter"
        >
          <DialogTitle className="keyword-dialog-header">{"Filter By"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              <div className="cnt_hdr_blw_wrap row">

                <div>

                  <div className="">
                    <div>
                      <span>Completed Date</span>
                      <Select
                        value={dEngineoption}
                        options={completedate}
                        placeholder="Select..."
                        onChange={(values) => {
                          setSelectval(values)
                          SetdEngineoption(values);
                        }}
                        styles={customDropdownStyles()}
                        menuPortalTarget={document.body}
                      />
                    </div>


                  </div>
                  <span className="text-error">{validation.dateerror}</span>
                </div>

              </div>
            </DialogContentText>
          </DialogContent>
          <DialogActions className="dialog-action-button">
            <button className="form_submit_btn" onClick={FilterFunction} style={{ cursor: 'pointer' }} >
              Submit
            </button>
            <button style={{ cursor: 'pointer' }} onClick={() => { closeModal(true) }}>close</button>
            <button
              className="form_submit_btn"
              style={{ cursor: "pointer" }}
              onClick={handleReset}
            >
              Reset
            </button>
          </DialogActions>
        </Dialog>






      </div>
      <RunReportNow RunReportPopShow={RunReportPopShow} SetRunReportPopShow={SetRunReportPopShow} RunReportType={RunReportType} />
      {!openCommonAlerts &&
        <CommonErrorAlert
          data={{
            apiopen: apiopen,
            apiErrorMsg: apierrorMsg,
            isIconStyled: true
          }}
          closeAlert={apihandleClose} />
      }

    </div>
  );
}
